<template>
  <div class="about">
    <nav-head :bg="false"></nav-head>
    <div class="ban-bg">
      <img src="~assets/images/about/txt-about.png">
    </div>
    <logo-title :titleData="titles[0]" :line="false"></logo-title>
    <div class="brand">
      <p>长沙像风像雨又像雾信息科技有限公司主营针对科研诚信的学术不端文献查重业务，自主开发运营Paper联盟平台系统，致力于为高校提供优质的查重服务。截止目前，已有超过千万用户使用，我们的客户包含毕业生、在读研博、教师、科研人员、出版编辑、学者。</p>
      <p>平台主要运营模式为代理商模式，湖南省潇湘三人行企业管理有限公司为其全国招商运营中心，旗下有将近800个合作代理，2021年度整个平台及代理商创造了亿级营业额，代理人均营业额达到了15万元以上。</p>
    </div>
    <div class="dev">
      <logo-title class="dev-tit" :titleData="titles[1]" :line="false" :bg="false"></logo-title>
      <div class="dev-history">
        <ul class="dev-list">
          <li>
            <div class="list-item">
              <div class="year">2012年</div>
              <div class="info">
                <p>触及市场</p>
                <div>面对只有人工检测的检测市场，我司尝试研究发现所有的人工检测流程都能通过自编的程序来代替,做到24小时无时差的工作
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list-item">
              <div class="year">2013年</div>
              <div class="info">
                <p>推动变革</p>
                <div>论文查重集成平台PAPER联盟正式上线，开启代理招商加盟，自此论文检测行业从人工检测迈入自动检测新时代
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list-item">
              <div class="year">2016年</div>
              <div class="info">
                <p>扩大规模</p>
                <div> 活跃加盟代理商突破千人
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list-item">
              <div class="year">2017年</div>
              <div class="info">
                <p>深受信赖</p>
                <div>自主研发学术论文检测系统，在全国700多万高校毕业生的基数下，
                  系统上线第1年，使用人数达150W,深受广大学生认可，并获得良好口碑
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list-item">
              <div class="year">2018年</div>
              <div class="info">
                <p>深度提升</p>
                <div>由纯线上销售开始布点线下高校，挖掘更多毕业生需求
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list-item">
              <div class="year">2019年</div>
              <div class="info">
                <p>巨幅收益</p>
                <div>平台代理商在平台的技术支持和资源支持下，
                  创造了近2亿的营业额
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <logo-title :titleData="titles[2]" :line="false"></logo-title>
    <div class="culture">
      <div class="cul-bg">
        <h4>文化理念</h4>
        <div class="line"></div>
        <p>成就他人，就是成就自己</p>
      </div>
      <div class="cul-bg">
        <h4>发展愿景</h4>
        <div class="line"></div>
        <p>以检测为基石，</p>
        <p>垂直发展学术产业链，</p>
        <p>力争成为中国学术服务提供商翘楚</p>
      </div>
    </div>
    <logo-title :titleData="titles[3]" :line="false"></logo-title>
    <div class="core">
      <div class="core-item">

        <div class="img">
          <img src="~assets/images/about/core1.png">
          <span>BANG</span>
        </div>
        <div class="txt">
          科班出身,拥有敏锐的市场洞察力，主管公司的整体架构、
          战略发展、市场导向、高新技术研发等工作
        </div>
      </div>
      <div class="core-item">
        <div class="img">
          <span>STEVEN</span>
          <img src="~assets/images/about/core2.png">
        </div>
        <div class="txt">
          运筹帷幄,统筹能力强,能充分把握互联网新商机到来的机会，
          在新媒体和互联网推广方面有着丰富的实战管理经验
        </div>
      </div>
    </div>
    <back-top></back-top>
    <footer-version></footer-version>
  </div>
</template>
<script>
  import {NavHead,FooterVersion,LogoTitle,BackTop} from "../components";
  import {linkRefresh} from "../common/mixin";

  export  default {
      name:'About',
      components:{
          NavHead,
          LogoTitle,
          FooterVersion,
          BackTop
      },
      data() {
          return {
            titles:[
              {
                title:'品牌介绍',
                txt:'COMPANY  PROFILE',
                space:15,
              },
              {
                title:'企业发展历程',
                txt:'ENTERPRISE DEVELOPMENT HISTORY',
                space:5,
              },
              {
                title:'企业文化',
                txt:'COMPANY  PROFILE',
                space:10,
              },
              {
                title:'核心团队组成',
                txt:'CORE TEAM COMPOSITION',
                space:5,
              }
            ]
          }
      },
    mixins:[linkRefresh]
  }
</script>
<style scoped lang="less">
  .ban-bg {
    background-image: url("~assets/images/about/ban-about.jpg");
    img {
      height: 84px;
    }
  }
  .brand {
    font-size: 20px;
    color: #8f8f8f;
    margin: 0 30px 30px;
    padding:30px 20px;
    border: 1px dashed #e8e8e8;
    text-indent: 2em;
    line-height: 32px;
    p {
      text-indent: 2em;
    }
    span {
      color: #4a96cf;
    }
  }
  .dev {
    height: 1377px;
    background:url("~assets/images/about/dev-bg.jpg") no-repeat center/100% 100%;
    .dev-history {
      padding: 0 50px;
    }
    .dev-list {
      list-style: none;
      padding: 30px 0;
      color: #fff;
      margin-right: 20px;
      position: relative;
      &:before {
        content: '';
        display: block;
        position: absolute;
        height: 90%;
        width: 1px;
        background: #fff;
        bottom:38px;
        left: -18px;
      }
      li {
        font-size: 20px;
        padding: 40px 0;
        .list-item {
          display: flex;
          /*align-items: center;*/
          .year {
            font-size: 24px;
            white-space: nowrap;
            padding: 1px 20px 20px;
            position: relative;
            &:before {
              content: '';
              width: 10px;
              height: 10px;
              background: #fff;
              border-radius: 50%;
              position: absolute;
              left: -22px;
              top: 0;
            }
          }
          .info {
            font-size: 20px;
            p{
              font-size: 30px;
              font-weight: bold;
              padding-bottom: 10px;
            }
          }
        }
      }
    }
  }
  .culture {
    display: flex;
    justify-content: space-around;
    padding: 30px 0;
    .cul-bg {
      width: 326px;
      height: 414px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #fff;
      padding: 120px 30px 0;
      box-sizing: border-box;
      background-image: url("~assets/images/about/culture1.jpg");
      &:last-child {
        background-image: url("~assets/images/about/culture2.jpg");
      }
      h4 {
        font-size: 36px;
      }
      .line {
        height: 1px;
        width: 40%;
        background: #fff;
        margin: 30px 0;
      }
      p {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
  .core {
    padding: 0 30px 40px;
    .core-item {
      position: relative;
      margin: 34px 0;
      .img {
        position: absolute;
        top: 15px;
        width: 175px;
        height: 175px;
        span {
          position: absolute;
          bottom: 30px;
          font-size: 36px;
          color: #cdcdcf;
          z-index: 5;
        }
        img {
          height: 175px;
        }
      }
      .txt {
        display: flex;
        align-items: center;
        border: 1px solid #e5e5e5;
        height: 206px;
        width: 602px;
        font-size: 24px;
        color: #707070;
        box-sizing: border-box;
      }
      &:nth-child(2n-1){
        .img {
            left: 0;
        }

        .txt {
          padding-left: 110px;
          padding-right: 25px;
          margin-left: 88px;
        }
        span {
          left: 50%;
          transform: translate(-50%,0);
        }
      }
      &:nth-child(2n){
        .img {
          right: 0;
        }
        .txt {
          padding-right: 110px;
          padding-left: 25px;
          margin-right: 88px;
        }
        span{
          right: 50%;
          transform: translate(50%,0);
        }
      }
    }
  }
</style>